import styled from 'styled-components'

export const CancelledCaseOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255,255,255,0.6);

  & > div {
    font-size: 16px;
    font-weight: bold;
    color: #000;
  }
`